module.exports = __webpack_public_path__ + "assets/img/19@3x.790ca4e4.png";